import React, { Component } from 'react'

import YearPicker from '../common/YearPicker'
import FileItem from '../FileItem'

import moment from 'moment'

import Backend from '../../../utils/Backend'
import Notify from '../../../utils/Notify'

export default class Other extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      isLoading: false,
    }
    this._loadReports()
  }

  _loadReports() {
    this.setState({ isLoading: true })
    Backend.getReports('investor_others')
      .then((response) => {
        this.setState({ data: response, isLoading: false })
      })
      .catch((error) => {
        Notify.error(error.message)
        this.setState({ isLoading: false })
      })
  }

  _renderLoading() {
    if (!this.state.isLoading) return null
    return (
      <div class="container">
        <div class="text-center mb-12">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    )
  }

  _renderNoResults() {
    let { data, isLoading } = this.state
    if (data.length <= 0 && !isLoading) {
      return (
        <div className="text-center mb-12">
          <h6
            className="mb-5"
            id="credit-ratings"
            data-kt-scroll-offset="{default: 100, lg: 150}"
          >
            No reports available
          </h6>
        </div>
      )
    }
  }

  _renderRows() {
    let { data, isLoading } = this.state
    if (data.length <= 0 && !isLoading) {
      return null
    }
    return data.map((item) => {
      return (
        <tr>
          <td>
            <div className="d-flex align-items-center">
              <div className="d-flex justify-content-start flex-column">
                <a
                  href="#"
                  className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                >
                  {item.title}
                </a>
                <span className="text-muted fw-bold text-muted d-block fs-7">
                  {moment(item.published_at).format('Do MMM YYYY')}
                </span>
              </div>
            </div>
          </td>
          <td className="text-end">
            <FileItem url={item.file_url} slug={item.slug} />
          </td>
        </tr>
      )
    })
  }

  render() {
    return (
      <div className="py-10 py-lg-20 bg-light">
        <div className="container">
          <div className="text-center mb-12">
            <h2
              className="mb-5"
              id="conversions-from-ifrs-to-us-gaap"
              data-kt-scroll-offset="{default: 100, lg: 150}"
            >
              OTHER
            </h2>
            <hr />
          </div>
          <div className="card mb-5 mb-xl-8">
            <div className="card-body py-3">
              <div className="table-responsive">
                <table className="table align-middle gs-0 gy-4">
                  <thead>
                    <tr className="fw-bolder text-muted bg-light">
                      <th className="ps-4 min-w-325px rounded-start">Title</th>
                      <th className="min-w-150px text-end pe-5">
                        Other Reports
                      </th>
                    </tr>
                  </thead>
                  <tbody>{this._renderRows()}</tbody>
                </table>
                {this._renderLoading()}
                {this._renderNoResults()}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
